<template>
    <div
        v-if="testimonials.length"
        class="md-testimonial layout6 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgType == 'color' ? bgColor : null
        }"
    >
        <div class="f-col reviews-container">
            <div class="reviews-wrap">
                <swiper v-bind="layout6SwiperOptions" :class="'len' + testimonials.length">
                    <slide v-for="(item, index) in testimonials" :key="index">
                        <div
                            class="review-slider-item"
                            @click="toViewMore(item)"
                        >
                            <p v-html="item.reviewContent" class="comment"></p>
                            <div v-if="item.reviewerName" class="review-name">
                                <span class="line"></span>
                                {{ item.reviewerName }}
                            </div>
                        </div>
                    </slide>
                </swiper>
                <div class="swiper-button-wrap" v-if="testimonials?.length > 1">
                    <span
                        class="swiper-button prevbutton"
                        :style="swiperBtnStyle"
                    >
                        <i class="iconfont icon-arrow_06_left"></i>
                    </span>
                    <span
                        class="swiper-button nextbutton"
                        :style="swiperBtnStyle"
                    >
                        <i class="iconfont icon-arrow_06_right"></i>
                    </span>
                </div>
            </div>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>
<script>
import common from '../index';
import mixinSlide from '../mixin-slide';
export default {
    mixins: [common, mixinSlide],
    computed: {
        layout6SwiperOptions() {
            return {
                ...this.options,
                spaceBetween: 20,
                autoHeight: true,
                loop: true
            };
        },
        swiperBtnStyle() {
            if (this.btnColor) {
                return {
                    color: this.btnColor,
                    borderColor: this.btnColor
                };
            }
            return {};
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-testimonial.layout6 {
    min-height: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.md-empty {
        min-height: auto;
    }

    @include media-600 {
        min-height: auto;
    }
    // .review-title {
    //     margin-bottom: 40px;
    //     font-weight: 700;
    // }
    .reviews-wrap {
        .swiper {
            .swiper-wrapper {
                align-items: center;
                .review-slider-item {
                    cursor: pointer;
                    .comment {
                        font-family: var(--mg-title-font);
                        color: var(--g-primary-color);
                        font-size: 34px;
        
                        line-height: 51px;
                        text-align: center;
                        min-height: 51px;
                        @include media-600 {
                            font-size: 20px;
                            font-weight: 500;
                            line-height: 30px;
                            min-height: 30px;
                        }
                    }
                    .review-name {
                        color: var(--g-text-color);
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 16px;
                        text-align: center;
                        margin-top: 30px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .line {
                            display: inline-block;
                            width: 25px;
                            height: 1px;
                            background: var(--g-text-color);
                            margin-right: 8px;
                        }
                    }
                }
            }
            &.len1 {
                .swiper-wrapper {
                    transform: translate3d(0px, 0px, 0px) !important;
                }
            }
        }
        .swiper-button-wrap {
            width: 130px;
            height: 50px;
            margin: 40px auto 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            @include media-600 {
                width: 80px;
                height: 30px;
            }

            .swiper-button {
                width: 50px;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid var(--g-btn-background);
                color: var(--g-btn-background);
                border-radius: 50%;
                cursor: pointer;
                i {
                    font-size: 14px;
                    line-height: 1;
                }
                &.navigation-disabled {
                    opacity: 0.3;
                    cursor: not-allowed;
                }
                @include media-600 {
                    width: 30px;
                    height: 30px;
                    i {
                        font-size: 10px;
                        font-weight: 700;
                    }
                }
            }
            .swiper-button:not(.navigation-disabled) {
                @include color-button-hover(50%);
            }
        }
    }
}
</style>
